import user from '@/store/mutations/user/index.js'
import site from '@/store/mutations/site/index.js'
import menu from '@/store/mutations/menu/index.js'
import nav from '@/store/mutations/nav/index.js'

import design from '@/store/mutations/design/index.js'
export default {
  ...user,
  ...site,
  ...menu,
  ...nav,

  ...design
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js